import { api } from "./api";

const basePath = "/employee";

export const createEmployee = async ({ name, phone, companyId }: any) => {
  try {
    const res = await api.post(`${basePath}`, {
      name,
      phone,
      companyId,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateEmployeeById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`${basePath}`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getEmployeeById = async (id: string) => {
  try {
    const res = await api.get(`${basePath}?_id=${id}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const getEmployeeList = async ({
  companyId,
  pageNumber,
  limit,
  sort,
  name,
}: {
  companyId?: string;
  pageNumber?: number;
  limit?: number;
  sort?: string;
  name?: string;
}) => {
  try {
    const params: Record<string, any> = {};
    if (companyId !== undefined) params.companyId = companyId;

    if (pageNumber !== undefined) params.pageNumber = pageNumber;
    if (limit !== undefined) params.limit = limit;
    if (sort !== undefined) params.sort = sort;
    if (name !== undefined) params.name = name;

    const res = await api.get(`${basePath}/list`, { params });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteEmployee = async ({ id, companyId }: any) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id, companyId: companyId },
    });
    return res;
  } catch (error) {
    return error;
  }
};
